import React from 'react';
import { StyledEngineProvider } from '@mui/material/styles';
import ColorModeProvider from './theme/ColorModeProvider';

function withRoot(Component) {
  function WithRoot(props) {
    return (
      <StyledEngineProvider injectFirst>
        <ColorModeProvider>
          <Component {...props} />
        </ColorModeProvider>
      </StyledEngineProvider>
    );
  }

  return WithRoot;
}

export default withRoot;
